module.exports = __webpack_public_path__ + "7a512f9e77578332140562ee45f69b7d.png";